import { DEVICE_AUTHORIZATION } from "@repo/database/constants";
export const CLIENT_ID = DEVICE_AUTHORIZATION.CLIENT_IDS[0];
